import React from "react";

const Title = () => {
  return (
    <div className="title">
      <h2>Your User Gallery</h2>
      <p>Add your photos..</p>
    </div>
  );
};

export default Title;
